import { apiFetch } from "../utils/apiFetch"

export function createSignature(data: any) {
  return apiFetch("/api/signatures", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function updateSignature(id: string, data: any) {
  return apiFetch(`/api/signatures/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function deleteSignature(id: string) {
  return apiFetch(`/api/signatures/${id}`, { method: "DELETE" })
}
